import React, { ReactNode } from 'react'
import WrapperElement from '@/components/elements/WrapperElement'
import { Heading1 } from '@/components/pages/checkout/common/Headings'
import NextImage from 'next/image'
import sandMassageImage from '@/components/pages/checkout/booking-page/booking-result/images/sand-massage.jpeg'
import infinityPoolImage from '@/components/pages/checkout/booking-page/booking-result/images/infinity-pool.jpeg'
import happyBestAgerCoupleImage from '@/components/pages/checkout/booking-page/booking-result/images/happy-best-ager-couple.jpeg'
import yogaInTheSunImage from '@/components/pages/checkout/booking-page/booking-result/images/yoga-in-the-sun.jpeg'
import ayurvedaOilImage from '@/components/pages/checkout/booking-page/booking-result/images/ayurveda-oil.jpeg'
import happyBestAgerImage from '@/components/pages/checkout/booking-page/booking-result/images/happy-best-ager.jpeg'
import { Payment } from '@/lib/payment/types'

export function CheckoutResult(props: {
  icon: ReactNode
  title: string
  message: ReactNode
  description?: ReactNode | undefined
  actionElement?: ReactNode
  formElement?: ReactNode
  payment?: Payment | undefined
  hideImages?: boolean
  footerElement?: ReactNode
}) {
  return (
    <WrapperElement
      classNamesInnerContainer="flex flex-grow flex-col justify-between"
      className="mb-16 flex flex-grow"
    >
      <div className="p-b-5 flex flex-grow flex-col items-center justify-start gap-y-4 pt-10 sm:p-5">
        {props.icon}
        <div className="text-start sm:text-center">
          <Heading1 className="mb-8">{props.title}</Heading1>
          {props.description && (
            <p className="mb-4 font-semibold">
              {props.description} <br />
            </p>
          )}
          <p className="prose mb-8">{props.message}</p>
        </div>
        {props.actionElement}
        {props.formElement}
        {!props.hideImages && (
          <div className="grid grid-cols-1 justify-center gap-4 tiny:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
            <NextImage
              src={sandMassageImage}
              width={292}
              height={194}
              alt=""
              className="aspect-[3/2] object-cover"
            />
            <NextImage
              src={infinityPoolImage}
              width={292}
              height={194}
              alt=""
              className="hidden aspect-[3/2] object-cover tiny:block"
            />
            <NextImage
              src={happyBestAgerCoupleImage}
              width={292}
              height={194}
              alt=""
              className="hidden aspect-[3/2] object-cover sm:block"
            />
            <NextImage
              src={yogaInTheSunImage}
              width={292}
              height={194}
              alt=""
              className="hidden aspect-[3/2] object-cover md:block"
            />
            <NextImage
              src={ayurvedaOilImage}
              width={292}
              height={194}
              alt=""
              className="hidden aspect-[3/2] object-cover lg:block"
            />
            <NextImage
              src={happyBestAgerImage}
              alt=""
              width={292}
              height={194}
              className="hidden aspect-[3/2] xl:block"
            />
          </div>
        )}
      </div>
      {props.footerElement}
    </WrapperElement>
  )
}
